import { useState, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useZusUserConnectedStore } from '@/helpers/user-auth.js';

const mapClass = {
  search_visible: 'bottom-0',
  search_no_visible: '-bottom-36',
  other_visible: 'bottom-0 translate-y-0',
  other_no_visible: 'bottom-0 translate-y-full',
};

export const useHeaderScroll = () => {
  const { comefrom } = useZusUserConnectedStore.getState();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const headerRef = useRef(null);
  const mobileHeaderRef = useRef(null);
  const lastScrollY = useRef(0);

  // Fonction pour mettre à jour les classes CSS
  const updateClasses = (element, visible, comefrom) => {
    if (!element) return;
    
    const classesToRemove = ['translate-y-full', 'translate-y-0', 'bottom-0', '-bottom-36'];
    classesToRemove.forEach(className => element.classList.remove(className));
    
    const key = `${comefrom === 'search' ? 'search' : 'other'}_${visible ? 'visible' : 'no_visible'}`;
    const newClasses = mapClass[key]?.split(' ') || [];
    newClasses.forEach(className => element.classList.add(className));
  };

  // Effet pour gérer le défilement
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Ignorer les valeurs de scroll négatives (bounce iOS)
      if (currentScrollY < 0) return;
      
      // Déterminer la direction du défilement
      const scrollingUp = currentScrollY < lastScrollY.current;
      
      // Mettre à jour l'état visible
      setVisible(scrollingUp);
      
      // Mettre à jour la position précédente
      lastScrollY.current = currentScrollY;
    };

    // Ajouter l'écouteur d'événement
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Nettoyer l'écouteur d'événement
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Effet pour mettre à jour les classes CSS lorsque l'état visible change
  useEffect(() => {
    updateClasses(headerRef.current, visible, comefrom);
    updateClasses(mobileHeaderRef.current, visible, comefrom);
  }, [visible, comefrom]);

  // Effet pour mettre à jour les classes CSS lorsque la page change
  useEffect(() => {
    updateClasses(headerRef.current, visible, comefrom);
    updateClasses(mobileHeaderRef.current, visible, comefrom);
  }, [searchParams, pathname]);

  return {
    headerRef,
    mobileHeaderRef,
    visible
  };
}; 